import React from "react";
import PropTypes from "prop-types";
import CustomField from "../../common/CustomField";

const AdditionalInfo = ({
    fields = [],
    subsectionHeading,
    additionalText = "",
}) =>
    fields.length > 0 && (
        <div className="grid">
            <div className="col col--12">
                <h3 className="-type--regular -margin-bottom--5">
                    {subsectionHeading}
                </h3>
                {additionalText && <small>{additionalText}</small>}
                <div className="grid">
                    {fields.map((field, i) => {
                        const {
                            id,
                            type,
                            display_text,
                            description,
                            helpText,
                            maxChar,
                        } = field;
                        const name = `Custom_Fields_${id}`;

                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <div key={i} className="col col--12">
                                <CustomField
                                    id={id}
                                    name={name}
                                    type={type}
                                    description={description}
                                    label={display_text}
                                    helpText={helpText}
                                    maxChar={String(maxChar)}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );

AdditionalInfo.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({})),
    subsectionHeading: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
};

export default AdditionalInfo;
